import { MoreHorizontal } from "lucide-react";
import { Fragment, type JSX, useId, useMemo } from "react";
import { Link } from "react-router-dom";

import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/DropdownMenu";

import { cn } from "@/utils/core/generalUtils";

interface WpxDropdownProps {
  data: ActionButtonDataTypes[];
}

export const WpxDropdown = ({ data }: WpxDropdownProps): JSX.Element => {
  const id = useId();

  const renderableItems = useMemo(
    () => data?.filter((item) => !item.hide),
    [data],
  );

  if (!renderableItems?.length) {
    return <></>;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='ghost' className='flex justify-center'>
          <MoreHorizontal className='w-4 h-4' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className='min-w-[200px] p-[6px] rounded-sm'
        align='end'
        key={id}
      >
        {data
          ?.filter((item) => !item.hide)
          .map((item) => {
            const Icon = item?.icon;

            if (item?.isLink) {
              return (
                <Link to={item.isLink} state={{ id: item?.id }} key={item.name}>
                  <DropdownMenuItem
                    className={cn(
                      `flex items-center  !pr-5 font-medium gap-2`,
                      item.isTrash && "text-red-600 hover:!text-red-600",
                      item?.textClassName,
                    )}
                  >
                    <Icon size={16} />
                    <span>{item.name}</span>
                  </DropdownMenuItem>
                </Link>
              );
            }

            if (item?.isCustom && item?.customComponent) {
              return (
                <Fragment key={item?.name}>{item.customComponent}</Fragment>
              );
            }

            return (
              <Fragment key={item.name}>
                <DropdownMenuItem
                  onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                    e.stopPropagation();
                    if (item.onClick) {
                      item.onClick();
                    }
                  }}
                  className={cn(
                    `flex items-center  !pr-5 font-medium gap-2`,
                    item.isTrash && "text-red-600 hover:!text-red-600",
                    item?.textClassName,
                  )}
                >
                  <Icon size={16} />
                  <span>{item.name}</span>
                </DropdownMenuItem>
              </Fragment>
            );
          })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
